module.exports = __webpack_public_path__ + "img/timconwayjr_hero_mobile.b3cfd1fe.png";